// idSlice.js
import { createSlice } from '@reduxjs/toolkit';

const adaptiveboard = createSlice({
  name: 'adaptiveboard',
  initialState: {
    adaptiveboardselectedId: {},
    adaptiveboardUserDetails:{}
  },
  reducers: {
    setadaptiveboardSelectedId: (state, action) => {
      state.adaptiveboardselectedId = action.payload;
    },

    setadaptiveboardUserDetails: (state, action) => {
      state.adaptiveboardselectedId = action.payload;
    },
  },
});

export const { setadaptiveboardSelectedId,setadaptiveboardUserDetails } = adaptiveboard.actions;
export default adaptiveboard.reducer;
